import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import TabStripTabViewModel from '@/ViewModels/Controls/TabStripTabViewModel';

export default class TabStripViewModel extends ControlViewModel {

    /**
     * Enthält die Kindelemente
     */
    public tabs: TabStripTabViewModel[];

    /**
     * Bestimmt den aktiven Tab
     */
    public selectedIndex: KnockoutObservable<number>;

    /**
     * Gibt an, ob der TabStrip eine WizardGroup darstellt
     */
    public isWizard: boolean;

    /**
     * Das ViewModel für den TabStrip
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.tabs = this.paramOrDefault(params.tabs, []);
        this.selectedIndex = this.observableOrDefault(params.selectedIndex, 0);
        this.isWizard = this.paramOrDefault(params.isWizard, false);
    }
}

ComponentManager.setViewModel('TabStripViewModel', TabStripViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');